import { useState } from 'react'
import { Link } from 'react-router-dom'
import { NO_IMAGE_DEFAULT } from 'constants/env'
import { priceFormat } from 'util/prices'
import { decodeStorage } from 'functions/storageBase64'
import styles from './styles.module.sass'

const FloatMenuCart = (props) => {
    const {
        eventId,
        cartId,
        coumtCant = 0,
        products,
        deleteProducts
    } = props

    const userProfile = decodeStorage('profileData')
    const idSears = userProfile ? String(userProfile?.idClaro) : null

    const [ showCart, setShowCart ] = useState(false)
    const toggleCart = () =>{
        setShowCart(!showCart)
    }

    const removeProduct = (producto) =>{
        const { productID, variation } = producto
        const event =  cartId
        deleteProducts(event, productID, variation)
    }

    return(
        <div className={styles?.contCartModule}>
            <div className={styles?.cartModule} onClick={toggleCart} aria-hidden>
                <i className="fa fa-gift fa-2x">
                    <span className={styles?.contCart}>{coumtCant}</span>
                </i>
            </div>
            <div className={showCart ? `${styles?.cartProducts} ${styles?.active}` : `${styles?.cartProducts}`}>
                {products
                    ? 
                        <div className={styles?.contProducts}>
                            <div className={styles?.contProductsHidden}>
                                {products.map((product, index) => {
                                    const image = product?.pictures ? product?.pictures[0]?.source : NO_IMAGE_DEFAULT
                                    return(
                                        <div className={styles?.cardProduct} key={index}>
                                            <img src={image} alt={product?.title} className={styles?.imageProduct} />
                                            <div>
                                                <p className={styles?.title}>{product?.title}</p>
                                                <p className={styles?.price}>${product?.pricing?.list_price ? priceFormat(product?.pricing?.list_price) : product?.pricing?.list_price} MXN</p>
                                                <div
                                                    aria-hidden
                                                    className="btn btn-primary secondaryButton" 
                                                    onClick={() => removeProduct({productID : product?.product_sears_id, variation: product?.variant_sears_id ? product?.variant_sears_id : null})}
                                                >Eliminar</div>  
                                            </div>
                                        </div>
                                    )
                                }
                            ) }
                            </div>
                            <Link to={idSears ? `/buy-gifts/${eventId}/buy` : `/pre-buy-gifts/${eventId}/buy`} className="btn btn-primary primaryButton" >Comprar ahora</Link>
                        </div>
                    : <div>No has agregado productos</div>
                }
            </div>
        </div>
    )
}

export default FloatMenuCart